export default {
  modalTitle: 'Куда вы собираетесь?',
} as const;
